<template>
  <div style="backgroud-color:#fff!important" v-if="loaded">
    <mdb-row class="mb-2">
      <mdb-col col="12">
        <div class="header-main">
          <mdb-icon class="mr-3" icon="arrow-left" />{{ advertisement.title }}
        </div>
      </mdb-col>
      <mdb-col col="12">
        <div
          class="center-cropped"
          :style="enLargened ? { height: imgy + 'px' } : { height: 160 + 'px' }"
        >
          <img
            :style="
              enLargened
                ? { marginTop: 0 }
                : { marginTop: -imgy / 2 + 80 + 'px' }
            "
            :src="this.advertisement.image + '?' + new Date().getTime()"
            alt="..."
          />
        </div>
        <img
          class="img-resizer"
          v-bind:style="
            enLargened
              ? 'transform: rotate(180deg);'
              : 'transform: rotate(0deg);'
          "
          @click="reSizeImage()"
          src="../assets/img/imagedown.png"
        />
      </mdb-col>
      <mdb-col
        class="margin20"
        col="12"
        v-for="(benefit, index) in benefits"
        v-bind:index="index"
        v-bind:key="index"
      >
        <CouponPreviewBenefit :benefit="benefit" />
      </mdb-col>
      <mdb-col col="12" class="margin10">
        <CouponPreviewFooter
          :description="advertisement.description"
          :web="advertisement.web"
        />
      </mdb-col>
    </mdb-row>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbIcon } from "mdbvue";
import CouponPreviewBenefit from "@/components/CouponPreviewBenefit";
import CouponPreviewFooter from "@/components/CouponPreviewFooter";

export default {
  name: "CouponPreview",
  components: {
    mdbRow,
    mdbCol,
    mdbIcon,
    CouponPreviewFooter,
    CouponPreviewBenefit,
  },
  props: {},
  data() {
    return {
      advertisementId: this.getAdvertisementId(),
      getadvertisementpath: "/2.0/advertisements?sessionid=",
      advertisement: null,
      benefits: [],
      loaded: false,
      enLargened: false,
      imgx: 0,
      imgy: 0,
      ImageHeight: 0,
    };
  },
  methods: {
    reSizeImage() {
      this.enLargened = !this.enLargened;
    },
    getAdvertisementId() {
      try {
        return parseInt(this.$route.path.match(/(\d+)/)[0]);
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    fillView() {},
    loadImage() {
      var _self = this;
      var newImg = new Image();
      newImg.crossOrigin = "anonymous";
      newImg.onload = function() {
        _self.imgy = newImg.naturalHeight / (newImg.naturalWidth / 410);
      };
      newImg.src = this.advertisement.image + "?" + new Date().getTime();
      console.log(newImg.src);
    },
    getAdvertisement() {
      this.$notify.info({
        message: this.$t("loading_advertisement"),
        position: "top right",
        timeOut: this.$store.state.notifytimeoutmedium,
      });
      this.$http
        .get(
          this.getadvertisementpath +
            this.$store.getters.getToken +
            "&advertisementid=" +
            this.advertisementId
        )
        .then((response) => {
          if (response.status == 200) {
            const now = new Date();
            now.setHours(23, 59, 59, 999);
            const advertisementtime = new Date(response.data.advertisements[0].todate);
            advertisementtime.setHours(23, 59, 59, 999);
            if (advertisementtime > now) {
              if (response.data.benefits !== undefined) {
                response.data.benefits.forEach((element) => {
                  let todate = new Date(element.todate);
                  todate.setHours(23, 59, 59, 999);
                  if (element.deleted == 0 && now <= todate) {
                    this.benefits.push(element);
                  }
                });
              }
            } else {
              this.benefits = response.data.benefits;
            }
            this.advertisement = response.data.advertisements[0];
            this.loadImage();
            this.loaded = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
  },
  mounted() {
    this.getAdvertisement();
  },
  computed: {},
};
</script>

<style scoped>
.center-cropped {
  width: 410px;
  height: 160px;
  overflow: hidden;
}

.center-cropped img {
  width: 410px;
  height: auto;
}

.header-main {
  width: 410px;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  font-size: 18px;
  font-weight: bold;
  background-color: #283c46;
  color: white;
  vertical-align: middle;
}
.img-resizer {
  width: 50px;
  height: 50px;
  margin-top: -25px;
  display: block;
  margin-left: auto;
  margin-right: 15px;
}
.margin20 {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
